import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Globe } from "lucide-react";
import ProtectedLogo from "@/components/bits/ProtectedLogo";

const COLS = [
  {
    title: "Company",
    links: [
      ["About Us", "/about"],
      ["Services", "/services"],
      ["Industries", "/industries"],
      ["Client Network", "/#clients"],
      ["Contact", "/contact"],
    ],
  },
  {
    title: "Students",
    links: [
      ["Careers & Jobs", "/careers"],
      ["Internships", "/internships"],
      ["Industrial Training", "/internships#training"],
      ["Submit Your Profile", "/careers#profile"],
    ],
  },
  {
    title: "Colleges",
    links: [
      ["Partner With Us", "/colleges"],
      ["TPO Programs", "/colleges#programs"],
      ["Recruitment Drives", "/colleges#process"],
    ],
  },
  {
    title: "Businesses",
    links: [
      ["Request Manpower", "/businesses#request"],
      ["Recruitment Process", "/process"],
      ["Workforce Solutions", "/services"],
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-darknavy noise-bg text-white relative" data-testid="site-footer">
      <div className="h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="rounded-lg inline-block mb-6 bg-white px-4 py-2.5">
              <ProtectedLogo alt="Maqline Solutions Pvt Ltd" className="h-9 w-auto" />
            </div>
            <p className="font-quote italic text-lightgold text-lg mb-3">"Connecting Talent With Opportunity."</p>
            <p className="text-white/55 text-sm leading-relaxed max-w-sm">
              Maqline Solutions Pvt Ltd is a workforce solutions company helping organizations meet manpower
              and recruitment requirements while creating career opportunities for students, freshers and job seekers.
            </p>
            <div className="mt-6 space-y-3 text-sm">
              <a href="mailto:info@maqlinesolutions.com" data-testid="footer-email" className="flex items-center gap-3 text-white/70 hover:text-lightgold transition-colors duration-300">
                <Mail size={15} className="text-gold" /> info@maqlinesolutions.com
              </a>
              <a href="https://www.maqlinesolutions.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 text-white/70 hover:text-lightgold transition-colors duration-300">
                <Globe size={15} className="text-gold" /> www.maqlinesolutions.com
              </a>
              <p className="flex items-start gap-3 text-white/70">
                <MapPin size={15} className="text-gold mt-0.5 shrink-0" />
                <span>Site No 8, MK Layout, Embassy Tech Village Back Gate,<br />Bhoganahalli, Bengaluru – 560103, Karnataka, India</span>
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
            {COLS.map((col) => (
              <div key={col.title}>
                <h4 className="text-[11px] uppercase tracking-[0.25em] font-bold text-lightgold mb-5">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map(([label, to]) => (
                    <li key={label}>
                      <Link
                        to={to}
                        data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                        className="text-sm text-white/60 hover:text-white transition-colors duration-300"
                      >
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/45">© 2026 Maqline Solutions Pvt Ltd. All Rights Reserved.</p>
          <div className="flex items-center gap-6 text-xs">
            <Link to="/legal#privacy" data-testid="footer-privacy" className="text-white/45 hover:text-lightgold transition-colors duration-300">Privacy Policy</Link>
            <Link to="/legal#terms" data-testid="footer-terms" className="text-white/45 hover:text-lightgold transition-colors duration-300">Terms & Conditions</Link>
            <Link to="/legal#disclaimer" data-testid="footer-disclaimer" className="text-white/45 hover:text-lightgold transition-colors duration-300">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
